import {has, isEmpty, map, pluck, reject, uniq, where} from 'underscore'
import {formatAsTitle} from '../../utils/string'

const initFormErrors = () => []

/**
 * @mixin
 */
export default {
    props: {
        /**
         * Array of validation errors
         * i.e. [{field: string, message: string}]
         */
        errors: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        formErrors: initFormErrors()
    }),
    methods: {
        clearFieldErrors (field) {
            const vm = this
            vm.formErrors = reject(vm.formErrors, {field})
        },
        initFormErrors,
        resetFormErrors () {
            const vm = this
            vm.formErrors = vm.initFormErrors()

            /**
             * Emit reset:errors event
             * @event reset:errors
             */
            this.$emit('reset:errors')
        },
        setFormErrors () {
            const vm = this
            vm.formErrors = [...vm.errors]
        }
    },
    computed: {
        formErrorsAlert () {
            let errorMessages = []

            if (!this.hasFormErrors) {
                return errorMessages
            }

            const errors = this.formErrors

            errorMessages = map(errors, (error) => {
                if (has(error, 'field') && !isEmpty(error.field)) {
                    return `There was an issue with the 
                    "${formatAsTitle(error.field)}" field.   ${error.message}`
                }

                return error.message
            })

            return {
                show: true,
                type: 'error',
                content: !isEmpty(errorMessages)
                    ? uniq(errorMessages)
                    : ['There was an error processing this form']
            }
        },
        fieldErrors () {
            const vm = this
            return (field) => {
                const errors = where(vm.formErrors, {field})
                return pluck(errors, 'message')
            }
        },
        hasFormErrors () {
            return !isEmpty(this.formErrors)
        }
    },
    watch: {
        errors () {
            this.setFormErrors()
        }
    },
    created () {
        this.setFormErrors()
    },
    destroyed () {
        this.resetFormErrors()
    }
}
